import Filter from '@/assets/icons/Filter';

import styles from './PanelHeader.module.css';

type PanelHeaderProps = {
  title: string;
  sectionId: string;
  onFilterMenuItemClick?: () => void;
  filterActive?: boolean;
};

function PanelHeader({ title, sectionId, onFilterMenuItemClick, filterActive }: Readonly<PanelHeaderProps>) {
  return (
    <div className={styles.panelHeaderStyle}>
      <span className={styles.panelHeaderTitleStyle}>{title}</span>
      <div className={styles.panelHeaderButtonBarStyle}>
        {onFilterMenuItemClick ? (
          <div
            className={styles.panelHeaderButtonStyle}
            data-active={filterActive ? 'yes' : 'no'}
            onClick={onFilterMenuItemClick}
            data-testid={`${sectionId}-filter`}
            title='Filter'
          >
            <Filter aria-hidden='true' />
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}

export default PanelHeader;
